module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-12",
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vue-select-search', {
    attrs: {
      "list": _vm.searchResult,
      "option-value": "value",
      "option-text": "label",
      "inputId": _vm.inputId,
      "id": _vm.inputId,
      "custom-text": _vm.displayOption,
      "filterPredicate": _vm.customFilter
    },
    on: {
      "searchchange": _vm.doSearch
    },
    model: {
      value: (_vm.selectedOption),
      callback: function($$v) {
        _vm.selectedOption = $$v
      },
      expression: "selectedOption"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Move"
    },
    on: {
      "click": _vm.moveElement
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("►")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_vm._l((_vm.valuesList), function(place, index) {
    return _c('div', {
      staticClass: "places"
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "background-color": "#EEEEEE",
        "margin-top": "1px",
        "margin-right": "1px"
      }
    }, [_c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "padding": "2px"
      }
    }, [_c('button', {
      staticClass: "close",
      attrs: {
        "type": "button",
        "aria-label": "Delete"
      },
      on: {
        "click": function($event) {
          _vm.removeElement(place)
        }
      }
    }, [_c('span', {
      staticClass: "align-middle",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])]), _vm._v("\n          " + _vm._s(_vm.showLabel(place)) + "\n        ")])])])
  }), _vm._v(" "), (_vm.value == null || _vm.value.length == 0) ? _c('div', {
    staticClass: "col-md-12 text-center align-middle"
  }, [_vm._v(_vm._s(_vm.emptyLabel))]) : _vm._e()], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.inputId)),
      expression: "errors.has(inputId)"
    }],
    staticClass: "help is-invalid"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.inputId)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84f29ffc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/place-input.vue
// module id = 560
// module chunks = 1